import React from "react";

export default function Admin() {
  return <div>will be admin</div>;
}
